import React, { CSSProperties } from "react";
import * as styles from "./editor-tool.module.scss";
import { classArr } from "../helper/style-helper";
import whitelabel from "../whitelabel";

interface EditorToolProps {
	icon: (size: number, color: string) => React.ReactNode;
	label: string;

	active?: boolean;
	disabled?: boolean;
	onClick?: VoidFunction;

	style?: CSSProperties;
	className?: string;
}

export default function EditorTool(props: EditorToolProps) {
	return (
		<button
			style={props.style}
			className={classArr(
				props.className,
				styles.container,
				props.active && styles.active,
			)}
			disabled={props.disabled}
			onClick={props.onClick}
		>
			{props.icon(
				24,
				props.active
					? whitelabel.palette.primary900
					: whitelabel.palette.secondary900,
			)}
			<span className={styles.label}>{props.label}</span>
		</button>
	);
}
